import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=5f772c96&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=5f772c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f772c96",
  null
  
)

export default component.exports